import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ListItem from "./list-item.js";
import LocaleStrings from "Languages";

class SocialList extends Component {
  renderList() {
    var items = _.map(this.props.socials, (social) => (
      <ListItem key={social.sociallinkid} social={social} />
    ));
    return items;
  }

  render() {
    return (
      <div className="social-content">
        <table className="table">
          <thead>
            <tr>
              <th>{LocaleStrings.social_th_socialtype}</th>
              <th>{LocaleStrings.social_th_link}</th>
              <th>{LocaleStrings.social_th_action}</th>
            </tr>
          </thead>
          <tbody className="tbody-background">{this.renderList()}</tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    socials: state.socials,
  };
}

export default connect(mapStateToProps)(SocialList);
